<template>

  <div>
    <div :id="'bg-wrapper_' + index" class="min-vh-100 min-vw-100 bg-wrapper" :class="{ highlight: index == 0 }">
      <div :id="'bg-image_' + index" v-if="item.img" class="bg-image bg-lazy" 
          v-lazy:background-image="item.img.url_resized_large">
      </div>
      <div v-else class="bg-image"></div>
    </div>
    <div :id="'headline_' + index" class="headline vh-100 min-vh-100 min-vw-100 d-flex align-items-center justify-content-center position-absolute">
      <div class="header-wrap">
        <h1 class="title" v-html="$t(iKey('intro_question', 'question', 'text')) + '<br>' + $t(iKey('related_intro_steps', item, 'copy'))"></h1>
      </div>

    </div>
  </div>

</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  name: 'Question',
  props: [
    'item',
    'index',
    'num_items'
  ],
  mounted(){
    var dur = this.windowHeight
    var isLast = (this.num_items - 1) == this.index
    var timeline = new TimelineMax()

    timeline.to('#bg-wrapper_' + this.index, 1, {className: "+=highlight"}, 0);

    let slideOffset = 0;
    let slideDuration = 0;
    let d = dur * 2;
    if(this.index == 0){
      slideOffset = 0;
      slideDuration = 0;
    }
    else if(this.index == 1){
      slideOffset = 0;
      slideDuration = d;
    }
    else{
      slideOffset = ((d * this.index)) - d
      if(isLast){
        slideDuration = (d * 1.0);
        slideOffset = ((d * this.index)) - (d * 1); 
      } else {
        slideDuration = d;
      }
    }

    const scene = this.$scrollmagic.scene({
        duration: slideDuration,
        offset: slideOffset
    })
    this.$scrollmagic.addScene(
      scene
        //.addIndicators({name: 'slide_' + this.$props.index})
        .setTween(timeline)
    )

    let headerOffset = 0;
    let headerDuration = 0;
    if(this.index == 0){
      headerDuration = dur;
      headerOffset = 0;
    }
    else if(this.index == 1){
      headerDuration = dur + 600;
      headerOffset = dur;
    }
    else {
      headerOffset =  (((d * this.index)) - d) + 600
      headerDuration = d;
      if(isLast){
        headerDuration = d * 2;
      }
    }

    const scene2 = this.$scrollmagic.scene({
       duration: headerDuration,
       offset: headerOffset
    })
    this.$scrollmagic.addScene(
      scene2
        //.addIndicators({name: 'question_' + this.$props.index})
        .setClassToggle('#headline_' + this.index, "highlight")
    )

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	/* font-size: 100%; */
	/* font: inherit; */
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
} */


h1 {
  vertical-align: baseline;
  background-color: white;
  color: #382e2b;
  display: inline;
  padding: 10px 10px;
  box-decoration-break: clone;
}
.title {
    line-height: 50px;
}
@media (min-width: 576px) { 
    .title {
        line-height: 64px;
    }
}
@media (min-width: 768px) { 
    .title {
        line-height: 72px;
    }
}
@media (min-width: 1367px) { 
    .title {
        line-height: 100px;
    }
}

.bg-wrapper {
  position: absolute;
  background-size: cover;
  bottom: -100%;
}
.bg-wrapper.highlight  {
  bottom: 0;
}
.bg-image { 
  width: 100%;
  height: 100vh;
  background-color: #382e2b;
  background-size: cover;
  background-position: 90%;
}

.bg-image.highlight {
  /* background-position-y: -20px; */
}

.headline {
  visibility: hidden;
  top: 0;
  z-index: 10;
  width: 55%;
}

.headline.highlight {
  visibility: visible;
}

.header-wrap {
  width: auto;
}
@media (min-width: 576px) {
  .header-wrap {
    width: auto;
  }
}

</style>

<style>
h1 em {
  font-weight: bold;
}
</style>